const defaultVisit = {
  FechaVisita: null,
  HoraInicio: null,
  HoraTermino: null,
  ObjetoVisita: null,
  CircunstanciaVisita: null,
  NoConformidadesEncargado: null,
  ObservacionesEncargado: null,
  Acciones: null,
  NombreCompletoPT1: null,
  FolioPT1: null,
  DomicilioPT1_T: null,
  NombreCompletoPT2: null,
  FolioPT2: null,
  DomicilioPT2_T: null,
  EqResistenciaAislamiento: null,
  ResResistenciaAislamiento: null,
  EqContinuidadElectrica: null,
  ResContinuidadElectrica: null,
  EqResistenciaTierraFisica: null,
  ResResistenciaTierraFisica: null,
  ResPolaridadContactos: null,
};

const getTemplateFields = (verification, visits) => {
  const visitsData = visits && visits.length > 0 ? visits : [defaultVisit];

  return {
    solicitud_acta_contrato: {
      "Razón social": verification?.NombreCompletoPV,
      "Dato de identificación de la Razón social": verification?.DatoPV_T,
      "Clasificación del SCIAN": verification?.ClasificacionSCIAN,
      "Nombre de la calle": verification?.NombreCalle,
      "Número oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      "Código postal": verification?.CodigoPostal,
      Municipio: verification?.Municipio,
      Ciudad: verification?.Ciudad,
      Estado: verification?.Estado,
      "Teléfono móvil Razón social": verification?.TelefonoMovilPV_T,
      "Correo electrónico de la Razón social": verification?.CorreoElectronicoPV_T,
      "Nombre de la persona que firma el contrato": verification?.NombreCompletoPF,
      "Dato de identificación de la persona que firma el contrato": verification?.DatoPF_T,
      "Teléfono móvil de la persona que firma el contrato": verification?.TelefonoMovilPF_T,
      "Correo electrónico de la persona que firma el contrato": verification?.CorreoElectronicoPF_T,
      "Nombre de la persona que atiende la visita": verification?.NombreCompletoPA,
      "Dato de identificación de la persona que atiende la visita": verification?.DatoPA_T,
      "Teléfono móvil de la persona que atiende la visita": verification?.TelefonoMovilPA_T,
      "Correo electrónico de la persona que atiende la visita": verification?.CorreoElectronicoPA_T,
      "Tensión eléctrica de suministro": verification?.TensionElectricaSuministro,
      "Capacidad de la subestación": verification?.Capacidad,
      "Tipo de instalación": verification?.TipoInstalacion,
      "Tipo de verificación": verification?.TipoVerificacion,
      "Carga instalada": verification?.CargaInstalada,
      "Alcance de la verificación": verification?.AlcanceVerificacion,
      "Fecha de recepción de la solicitud": verification?.FechaRecepcion,
      "Nombre de la persona que solicita la verificación": verification?.NombreCompletoPS,
      "Tipo de identificación de la persona que firma el contrato": verification?.TipoDatoPF_T,
      Monto: verification?.Monto,
      "Fecha del contrato": verification?.FechaContrato,
      "Cargo de la persona que atiende la visita": verification?.CargoPA,
      "Documento de origen del folio de identificación de la persona que atiende la visita": verification?.DocumentoOrigenPA,
      "Folio de la identificación de la persona que atiende la visita": verification?.FolioPA_T,
      "Entidad que expide la identificación de la persona que atiende la visita": verification?.ExpedidoPorPA,
      "Domicilio de la persona que atiende la visita": verification?.DomicilioPA_T,
    },
    solicitud: {
      "Razón social": verification?.NombreCompletoPV,
      "Dato de identificación de la Razón social": verification?.DatoPV_T,
      "Clasificación del SCIAN": verification?.ClasificacionSCIAN,
      "Nombre de la calle": verification?.NombreCalle,
      "Número oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      "Código postal": verification?.CodigoPostal,
      Municipio: verification?.Municipio,
      Ciudad: verification?.Ciudad,
      Estado: verification?.Estado,
      "Teléfono móvil Razón social": verification?.TelefonoMovilPV_T,
      "Correo electrónico de la Razón social": verification?.CorreoElectronicoPV_T,
      "Nombre de la persona que firma el contrato": verification?.NombreCompletoPF,
      "Dato de identificación de la persona que firma el contrato": verification?.DatoPF_T,
      "Teléfono móvil de la persona que firma el contrato": verification?.TelefonoMovilPF_T,
      "Correo electrónico de la persona que firma el contrato": verification?.CorreoElectronicoPF_T,
      "Nombre de la persona que atiende la visita": verification?.NombreCompletoPA,
      "Dato de identificación de la persona que atiende la visita": verification?.DatoPA_T,
      "Teléfono móvil de la persona que atiende la visita": verification?.TelefonoMovilPA_T,
      "Correo electrónico de la persona que atiende la visita": verification?.CorreoElectronicoPA_T,
      "Tensión eléctrica de suministro": verification?.TensionElectricaSuministro,
      "Capacidad de la subestación": verification?.Capacidad,
      "Tipo de instalación": verification?.TipoInstalacion,
      "Tipo de verificación": verification?.TipoVerificacion,
      "Carga instalada": verification?.CargaInstalada,
      "Alcance de la verificación": verification?.AlcanceVerificacion,
      "Fecha de recepción de la solicitud": verification?.FechaRecepcion,
    },
    contrato: {
      "Nombre de la persona que solicita la verificación": verification?.NombreCompletoPS,
      "Nombre de la persona que firma el contrato": verification?.NombreCompletoPF,
      "Tipo de identificación de la persona que firma el contrato": verification?.TipoDatoPF_T,
      "Dato de identificación de la persona que firma el contrato": verification?.DatoPF_T,
      "Teléfono móvil de la persona que firma el contrato": verification?.TelefonoMovilPF_T,
      "Correo electrónico de la persona que firma el contrato": verification?.CorreoElectronicoPF_T,
      "Razón social": verification?.NombreCompletoPV,
      "Nombre de la calle": verification?.NombreCalle,
      "Número oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      "Código postal": verification?.CodigoPostal,
      Ciudad: verification?.Ciudad,
      Municipio: verification?.Municipio,
      Estado: verification?.Estado,
      Monto: verification?.Monto,
      "Tensión eléctrica de suministro": verification?.TensionElectricaSuministro,
      "Capacidad de la subestación": verification?.Capacidad,
      "Tipo de instalación": verification?.TipoInstalacion,
      "Tipo de verificación": verification?.TipoVerificacion,
      "Carga instalada": verification?.CargaInstalada,
      "Alcance de la verificación": verification?.AlcanceVerificacion,
      "Fecha del contrato": verification?.FechaContrato,
    },
    acta: {
      "Razón social": verification?.NombreCompletoPV,
      "Clasificación del SCIAN": verification?.ClasificacionSCIAN,
      "Nombre de la calle": verification?.NombreCalle,
      "Número oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      Municipio: verification?.Municipio,
      "Código postal": verification?.CodigoPostal,
      Ciudad: verification?.Ciudad,
      Estado: verification?.Estado,
      "Teléfono móvil Razón social": verification?.TelefonoMovilPV_T,
      "Correo electrónico de la Razón social": verification?.CorreoElectronicoPV_T,
      "Nombre de la persona que atiende la visita": verification?.NombreCompletoPA,
      "Cargo de la persona que atiende la visita": verification?.CargoPA,
      "Folio de la identificación de la persona que atiende la visita": verification?.FolioPA_T,
      "Domicilio de la persona que atiende la visita": verification?.DomicilioPA_T,
      ...(visitsData.reduce((acc, visit, index) => {
        return {
          ...acc,
          [`Visita ${index + 1} - Objeto de la visita`]: visit?.ObjetoVisita,
          [`Visita ${index + 1} - Hora de inicio`]: visit?.HoraInicio,
          [`Visita ${index + 1} - Hora de término`]: visit?.HoraTermino,
          [`Visita ${index + 1} - Circunstancias de la visita`]: visit?.CircunstanciaVisita,
          [`Visita ${index + 1} - No conformidades`]: visit?.NoConformidadesEncargado,
          [`Visita ${index + 1} - Observaciones`]: visit?.ObservacionesEncargado,
          [`Visita ${index + 1} - Acciones`]: visit?.Acciones,
          [`Visita ${index + 1} - Nombre testigo 1`]: visit?.NombreCompletoPT1,
          [`Visita ${index + 1} - Folio testigo 1`]: visit?.DatoPT1_T,
          [`Visita ${index + 1} - Domicilio testigo 1`]: visit?.DomicilioPT1_T,
          // [`Visita ${index + 1} - Nombre testigo 2`]: visit?.NombreCompletoPT2,
          // [`Visita ${index + 1} - Folio testigo 2`]: visit?.DatoPT2_T,
          // [`Visita ${index + 1} - Domicilio testigo 2`]: visit?.DomicilioPT2_T,
        };
      }, {})),
    },
    informe: {
      "Razón social": verification?.NombreCompletoPV,
      "Número de control interno": verification?.ControlInterno,
      ...(visitsData.reduce((acc, visit, index) => {
        return {
          ...acc,
          [`Visita ${index + 1} - Fecha`]: visit?.FechaVisita?.split("T")[0],
          [`Visita ${index + 1} - Equipo resistencia de aislamiento`]: visit?.EqResistenciaAislamiento,
          [`Visita ${index + 1} - Resultado resistencia de aislamiento`]: visit?.ResResistenciaAislamiento,
          [`Visita ${index + 1} - Equipo continuidad eléctrica`]: visit?.EqContinuidadElectrica,
          [`Visita ${index + 1} - Resultado continuidad eléctrica`]: visit?.ResContinuidadElectrica,
          [`Visita ${index + 1} - Equipo resistencia de tierra física`]: visit?.EqResistenciaTierraFisica,
          [`Visita ${index + 1} - Resultado resistencia de tierra física`]: visit?.ResResistenciaTierraFisica,
          [`Visita ${index + 1} - Resultado polaridad de contactos`]: visit?.ResPolaridadContactos,
        };
      }, {})),
    },
    portada: {
      "Nombre de la calle": verification?.NombreCalle,
      "Número oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      Municipio: verification?.Municipio,
      Ciudad: verification?.Ciudad,
      Estado: verification?.Estado,
      "Código postal": verification?.CodigoPostal,
      "Aplica NOM 007": verification?.Nom007,
      "Aplica NOM 013": verification?.Nom013,
      "Folio de la AMUVIE": verification?.FolioAmuvie,
    },
    anexob: {
      "Razón social": verification?.NombreCompletoPV,
      "Número de control interno": verification?.ControlInterno,
      "Nombre de la calle": verification?.NombreCalle,
      "Numero oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      Municipio: verification?.Municipio,
      Estado: verification?.Estado,
    },
    etiqueta: {
      "Número de control interno": verification?.ControlInterno,
      "Razón social": verification?.NombreCompletoPV,
      "Clasificación del SCIAN": verification?.ClasificacionSCIAN,
    },
    vistaprevia: {
      "Razón social": verification?.NombreCompletoPV,
      "Tipo de identificación de la Razón social": verification?.TipoDatoPV_T,
      "Dato de identificación de la Razón social": verification?.DatoPV_T,
      "Clasificación del SCIAN": verification?.ClasificacionSCIAN,
      "Capacidad de la subestación": verification?.Capacidad,
      "Carga instalada": verification?.CargaInstalada,
      "Alcance de la verificación": verification?.AlcanceVerificacion,
      "Nombre de la calle": verification?.NombreCalle,
      "Número oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      Municipio: verification?.Municipio,
      Ciudad: verification?.Ciudad,
      Estado: verification?.Estado,
      "Código postal": verification?.CodigoPostal,
      "Teléfono móvil de la Razón social": verification?.TelefonoMovilPV_T,
      "Correo electrónico de la Razón social": verification?.CorreoElectronicoPV_T,
      "Nombre de la persona que solicita la verificación": verification?.NombreCompletoPS,
      "Tipo de identificación de la persona que solicita la verificación": verification?.TipoDatoPS_T,
      "Dato de identificación de la persona que solicita la verificación": verification?.DatoPS_T,
      "Teléfono móvil de la persona que solicita la verificación": verification?.TelefonoMovilPS_T,
      "Correo electrónico de la persona que solicita la verificación": verification?.CorreoElectronicoPS_T,
    },
    dictamen_007: {
      "Número de control interno": verification?.ControlInterno,
      "Fecha del dictamen (solicitud)": verification?.FechaRecepcion,
      "Razón social": verification?.NombreCompletoPV,
      "Tipo de verificación": verification?.TipoVerificacion,
      "Carga instalada": verification?.CargaInstalada,
      "Superficie para DPEA": verification?.SuperficieDPEA,
      "Nombre de la calle": verification?.NombreCalle,
      "Número oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      Municipio: verification?.Municipio,
      Ciudad: verification?.Ciudad,
      Estado: verification?.Estado,
      "Código postal": verification?.CodigoPostal,
      "Nombre de la persona que firma el contrato": verification?.NombreCompletoPF,
      "Telefono móvil de la persona que firma el contrato": verification?.TelefonoMovilPF_T,
      "Correo electrónico de la persona que firma el contrato": verification?.CorreoElectronicoPF_T,
    },
    dictamen_013: {
      "Número de control interno": verification?.ControlInterno,
      "Fecha del dictamen (solicitud)": verification?.FechaRecepcion,
      "Razón social": verification?.NombreCompletoPV,
      "Tipo de verificación": verification?.TipoVerificacion,
      "Carga instalada": verification?.CargaInstalada,
      "Superficie para DPEA": verification?.SuperficieDPEA,
      "Tipo de vialidad": verification?.TipoVialidad,
      "Nombre de la calle": verification?.NombreCalle,
      "Número oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      Municipio: verification?.Municipio,
      Ciudad: verification?.Ciudad,
      Estado: verification?.Estado,
      "Código postal": verification?.CodigoPostal,
      "Nombre de la persona que firma el contrato": verification?.NombreCompletoPF,
      "Telefono móvil de la persona que firma el contrato": verification?.TelefonoMovilPF_T,
      "Correo electrónico de la persona que firma el contrato": verification?.CorreoElectronicoPF_T,
    },
    supervision: {
      "Número de control interno": verification?.ControlInterno,
    },
    circunstanciada: {
      "Razón social": verification?.NombreCompletoPV,
      "Clasificación del SCIAN": verification?.ClasificacionSCIAN,
      "Nombre de la calle": verification?.NombreCalle,
      "Número oficial": verification?.NumeroOficial,
      Colonia: verification?.ColoniaOAsentamiento,
      Municipio: verification?.Municipio,
      "Código postal": verification?.CodigoPostal,
      Ciudad: verification?.Ciudad,
      Estado: verification?.Estado,
      "Teléfono móvil Razón social": verification?.TelefonoMovilPV_T,
      "Correo electrónico de la Razón social": verification?.CorreoElectronicoPV_T,
      "Nombre de la persona que atiende la visita": verification?.NombreCompletoPA,
      "Cargo de la persona que atiende la visita": verification?.CargoPA,
      "Folio de la identificación de la persona que atiende la visita": verification?.FolioPA_T,
      "Domicilio de la persona que atiende la visita": verification?.DomicilioPA_T,
      ...(visitsData.reduce((acc, visit, index) => {
        return {
          ...acc,
          [`Visita ${index + 1} - Objeto de la visita`]: visit?.ObjetoVisita,
          [`Visita ${index + 1} - Hora de inicio`]: visit?.HoraInicio,
          [`Visita ${index + 1} - Hora de término`]: visit?.HoraTermino,
          [`Visita ${index + 1} - Circunstancias de la visita`]: visit?.CircunstanciaVisita,
          [`Visita ${index + 1} - No conformidades`]: visit?.NoConformidadesEncargado,
          [`Visita ${index + 1} - Observaciones`]: visit?.ObservacionesEncargado,
          [`Visita ${index + 1} - Acciones`]: visit?.Acciones,
          [`Visita ${index + 1} - Nombre testigo 1`]: visit?.NombreCompletoPT1,
          [`Visita ${index + 1} - Folio testigo 1`]: visit?.DatoPT1_T,
          [`Visita ${index + 1} - Domicilio testigo 1`]: visit?.DomicilioPT1_T,
          // [`Visita ${index + 1} - Nombre testigo 2`]: visit?.NombreCompletoPT2,
          // [`Visita ${index + 1} - Folio testigo 2`]: visit?.DatoPT2_T,
          // [`Visita ${index + 1} - Domicilio testigo 2`]: visit?.DomicilioPT2_T,
        };
      }, {})),
    },
  };
};

export default getTemplateFields;